import { createApp } from 'vue';
import RarToTarConverter from '@/Components/RarToTarConverter.vue';
import '@styles/app.css';

createApp(RarToTarConverter).mount('#rar-to-tar-converter');
